import React from 'react'
import { Table } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { openBusinessInfoModalDialog } from '../../actions/business_info_modal_dialog'
import BusinessInfoModalDialog from './business_info_modal_dialog'

const BusinessInfo = ({ data, openBusinessInfoModalDialog }) => (
  <div className='ibox float-e-margins animated fadeIn section-shadow'>
    <div className='ibox-title round-corner-box-top'>
      <h5>Business Information {data.id}</h5>
    </div>
    <div className='ibox-content round-corner-box-bottom'>
      <Table striped bordered hover>
        <tbody>
          <tr>
            <th width={250}>Corporation Name</th>
            <td>{data.name}</td>
          </tr>
          {data.ein && (
            <tr>
              <th width={250}>Business ID number</th>
              <td>{data.ein}</td>
            </tr>
          )}

          <tr>
            <th width={250}>Email</th>
            <td>{data.email}</td>
          </tr>
        </tbody>
      </Table>
      <div className='text-center'>
        <button className='btn btn-info' type='button' onClick={() => openBusinessInfoModalDialog(data.id)}>
          <i className='fa fa-paste' /> Edit
        </button>
      </div>
    </div>
    <BusinessInfoModalDialog data={data} />
  </div>
)

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openBusinessInfoModalDialog,
    },
    dispatch
  )

export default withRouter(connect(null, mapDispatchToProps)(BusinessInfo))
